import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoModule} from '@jsverse/transloco';

import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';

import {SharedModule} from '../../shared/shared.module';
import {CoreModule} from '../../core/core.module';

import {SensorComponent} from './sensor.component';
import {SensorsListComponent} from './sensors-list/sensors-list.component';
import {SensorRestApiService} from './services/http/sensor-rest-api.service';
import {SensorResolver} from './services/resolver/sensor.resolver';
import {BatchCreateSensorComponent} from './batch-create-sensor/batch-create-sensor.component';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatBadgeModule} from '@angular/material/badge';
import {CreateOrderDialogComponent} from './create-order-dialog/create-order-dialog.component';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';


@NgModule({
  declarations: [
    SensorComponent,
    SensorsListComponent,
    BatchCreateSensorComponent,
    CreateOrderDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslocoModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatInputModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatBadgeModule,

    SharedModule,
    CoreModule,
    MatAutocomplete,
    MatAutocompleteTrigger,
  ],
  providers: [
    SensorRestApiService,
    SensorResolver,
  ],
})
export class SensorModule {
}
